export const API_URL = API_URL_ENV;
export const CDN_URL = CDN_URL_ENV;
export const HOST_PROTOCOL = HOST_PROTOCOL_ENV;
export const HOST_DOMAIN = HOST_DOMAIN_ENV;
export const HOST_MAIN = `www.${HOST_DOMAIN_ENV}`;
export const CMS_API = CMS_API_ENV;
export const SENTRY_HOST = SENTRY_HOST_ENV;
export const CI = CI_ENV;
export const VERSION = VERSION_ENV;
